import { MapSearchBlockContent } from '../../../../interfaces/map.interface';
import { SearchBlockContentStrategy } from './search-block-content.strategy';

export class SpecialitiesAndDiseasesSearchBlockContentStrategy extends SearchBlockContentStrategy {
  public constructor(mapSearchBlockContent: MapSearchBlockContent) {
    super(mapSearchBlockContent);
  }

  public emitSearchFormContent(): void {
    this.updateFieldsVisibility({
      roles: { hidden: true },
      charity_focuses: { hidden: true, disabled: true },
    });
  }

  public unsubscribeToSearchBlockFieldChanges(): void {
    //Simply ignore
  }
}

export class CommunitiesContentStrategy extends SearchBlockContentStrategy {
  public constructor(mapSearchBlockContent: MapSearchBlockContent) {
    super(mapSearchBlockContent);
  }

  public emitSearchFormContent(): void {
    this.updateFieldsVisibility({
      roles: { hidden: true },
      charity_focuses: { hidden: false, disabled: false },
    });
  }

  public unsubscribeToSearchBlockFieldChanges(): void {
    //Simply ignore
  }
}
